import * as React from 'react';

import DatePicker from './DatePicker';
import { InputError } from '../../common/utils';

interface Props {
	name: string;
	labelText?: string;
	placeholder?: string;
	value?: string | Date;
	dateRangeStart?: Date;
	dateRangeEnd?: Date;
	onBlur?: (e: any) => void;
	onChange?: (value?: Date, value2?: Object) => void;
	defaultValue?: string;
	required?: boolean;
	className?: string;
	id?: string;
	error?: InputError;
	disabled?: boolean;
}
const BirthDatePicker: React.StatelessComponent<Props> = props => {
	const currentDate = new Date();
	const currentYear = currentDate.getFullYear();

	return (
		<DatePicker
			name={props.name}
			labelText={props.labelText}
			placeholder={props.placeholder}
			value={props.value}
			dateRangeStart={props.dateRangeStart || new Date(currentYear - 100, 0)}
			dateRangeEnd={props.dateRangeEnd || new Date(currentYear, currentDate.getMonth())}
			onBlur={props.onBlur}
			onChange={props.onChange}
			defaultValue={props.defaultValue}
			required={props.required}
			className={props.className}
			id={props.id}
			error={props.error}
			disabled={props.disabled}
		/>
	);
};

export default BirthDatePicker;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/BirthDatePicker.tsx